module.exports = __webpack_public_path__ + "img/error-icon.01023736.svg";